export default "__VITE_ASSET__CzMLG3Yy__"